import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  Row,
  Col,
  Container,
  Button,
  FloatingLabel,
  Form,
  InputGroup,
} from "react-bootstrap";
import DetailLayout from "../../../../components/DetailLayout";
import RedeemModal from "../../../../components/RedeemModal";
import { RedeemDialog } from "../../../../components/DialogCollection";
import * as Assets from "../../../../utils/svg_assets";
import * as PageRoutes from "../../../../utils/route_pages";
import { dateFormater } from "../../../../utils/utilities";
import "./style.scss";
import parse from "html-react-parser";
import { myVoucherInfo } from "../../../../utils/constant";
import Tabs from "../../../../components/Tabs";

const VoucherDetail = (props) => {
  let { url_category, voucherId } = useParams();
  const navigate = useNavigate();
  const search = useLocation().search;
  const previouspage = new URLSearchParams(search).get("previouspage");
  const orgData = useSelector((state) => state.LoginSM.orgData);
  const [payload, setPayload] = useState({});
  const [openRedeemModal, setOpenRedeemModal] = useState(false);
  const [openRedeemDialog, setOpenRedeemDialog] = useState(false);
  const [resultData, setResultData] = useState({});
  const [showPlnNumber, setShowPlnNumber] = useState("password");
  const [isLoading, setIsLoading] = useState(false);

  const {
    reward_vouchers_detail,
    getRewardDetails,
    redemptionVoucher,
    setFinanceState,
    pointSummaryData,
    profile,
    setLoginData,
  } = props;

  const [activeTabs, setActiveTabs] = useState(1);
  const cust_email = profile.user_details.email;
  const cust_id = profile.user_details.pk;
  const cust_phone = profile.user_details.phone_number;

  const onChangeTabs = (tabActive) => {
    setActiveTabs(tabActive);
  };

  const onChangePhoneNumber = (valuePhone) => {
    if (valuePhone.length > 13) return;

    setPayload({ ...payload, phone: valuePhone });
  };

  useEffect(() => {
    getRewardDetails({ id: voucherId });
  }, []);

  const redeemProcess = async (point) => {
    let dataPayload;
    const newDataPoint = {
      ...pointSummaryData,
      remaining_points: pointSummaryData.remaining_points - point,
      redeemed_points: pointSummaryData.redeemed_points + point,
    };

    const newProfilePoint = {
      ...profile,
      user_details: {
        ...profile.user_details,
        points: profile.user_details.points - point,
      },
    };

    switch (reward_vouchers_detail.redemption_type) {
      case "mobile_topup":
        dataPayload = {
          reward: voucherId,
          user_data: {
            mobile: payload.phone,
          },
        };
        break;
      case "data_topup":
        dataPayload = {
          reward: voucherId,
          user_data: {
            customer_id: cust_id,
          },
        };
        break;
      case "electricity_topup":
        dataPayload = {
          reward: voucherId,
          user_data: {
            pln_number: payload.number,
          },
        };
        break;
      case "e_voucher":
        dataPayload = {
          reward: voucherId,
          user_data: {
            phone: cust_phone,
            email: cust_email,
          },
        };
        break;
      case "voucher_topup":
        dataPayload = {
          reward: voucherId,
          user_data: {},
        };
        break;
      case "new_evoucher":
        dataPayload = {
          reward: voucherId,
          user_data: {
            email: cust_email,
          },
        };
        break;
      case "giftn":
        dataPayload = {
          reward: voucherId,
          user_data: {
            email: cust_email,
          },
        };
        break;
      case "gopay":
        dataPayload = {
          reward: voucherId,
          user_data: {
            mobile: payload.phone,
          },
        };
        break;
      case "balance_topup":
        dataPayload = {
          reward: voucherId,
          user_data: {
            mobile: payload.phone,
          },
        };
        break;
      case "prezent":
        dataPayload = {
          reward: voucherId,
          user_data: {
            phone: cust_phone ? cust_phone : "null",
            email: cust_email,
          },
        };
        break;
      case "aldmic_voucher":
        dataPayload = {
          reward: voucherId,
          user_data: {
            email:
              profile?.organization_username_field == 1
                ? cust_email
                : cust_phone,
          },
        };
        break;
      default:
        dataPayload = {
          reward: voucherId,
          user_data: {
            phone: cust_phone,
            email: cust_email,
          },
        };
        break;
    }

    if (reward_vouchers_detail.redemption_type === "dana_cash_transfer") {
      navigate(`/reward/cash-transfer/${voucherId}`);
    } else {
      setIsLoading(true);

      await redemptionVoucher(dataPayload).then((result) => {
        if (result.status === 200) {
          setFinanceState({ pointSummaryData: newDataPoint });
          setLoginData({ login: newProfilePoint });
        }
        setResultData(result);
        setOpenRedeemModal(false);
        setOpenRedeemDialog(true);
        setIsLoading(false);
      });
    }
  };

  return (
    <DetailLayout
      headerImg={reward_vouchers_detail.display_img_url}
      backPage={
        previouspage === "reward"
          ? PageRoutes.reward
          : `/reward/voucher/${url_category}`
      }
    >
      <Container>
        <div className="detail-name">{reward_vouchers_detail.name}</div>
        <div
          className="detail-description"
          dangerouslySetInnerHTML={{
            __html: reward_vouchers_detail.description,
          }}
        />
        <Row>
          <Col>
            <Row>
              <Col xs={1} sm={1} md={1}>
                <img
                  src={Assets.iconOval}
                  className="icon-coin"
                  alt="icon-coin"
                />
              </Col>
              <Col className="point-req">
                {reward_vouchers_detail.points_label} points required
              </Col>
            </Row>
          </Col>
          <Col align="right">
            <Row>
              <Col className="qty-available">
                {reward_vouchers_detail.is_quantity
                  ? `Available quantity ${reward_vouchers_detail.quantity}`
                  : ``}
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="detail-valid">
          {reward_vouchers_detail.valid_until
            ? `Valid Until ${dateFormater(reward_vouchers_detail.valid_until)}`
            : ""}
        </div>
        <div className="detail-contact">
          <Row>
            <Col className="contact-label">Contact</Col>
          </Row>
          <Row className="contact-email">
            <Col xs={1} sm={1} md={1}>
              <img
                src={Assets.iconEmail}
                className="icon-email"
                alt="icon-email"
              />
            </Col>
            <Col>{reward_vouchers_detail.contact_details.email}</Col>
          </Row>
          <Row className="contact-phone">
            <Col xs={1} sm={1} md={1}>
              <img
                src={Assets.iconSupportCall}
                className="icon-phone"
                alt="icon-phone"
              />
            </Col>
            <Col>{reward_vouchers_detail.contact_details.phone}</Col>
          </Row>
          <Row className="contact-website">
            <Col xs={1} sm={1} md={1}>
              <img
                src={Assets.iconTopup}
                className="icon-website"
                alt="icon-website"
              />
            </Col>
            <Col>{reward_vouchers_detail.website}</Col>
          </Row>
        </div>
        <div className="detail-tab">
          <div className="d-flex wrapper-tab justify-content-between align-items-center overflow-unset">
            {myVoucherInfo.map((cat, index) => (
              <Tabs
                id={cat.id}
                key={index}
                name={cat.name}
                isActive={activeTabs}
                isStrong={false}
                onClick={() => onChangeTabs(cat.id, cat.name)}
              />
            ))}
          </div>
          {activeTabs === 1 && (
            <Row className="detail-tab-info">
              <div className="detail-howtouse">
                {parse(
                  reward_vouchers_detail.how_to_use
                    ? reward_vouchers_detail.how_to_use
                    : ""
                )}
              </div>
            </Row>
          )}
          {activeTabs === 2 && (
            <Row className="detail-tab-info">
              <div className="detail-howtouse">
                {parse(
                  reward_vouchers_detail.merchant.description
                    ? reward_vouchers_detail.merchant.description
                    : ""
                )}
              </div>
            </Row>
          )}
          {activeTabs === 3 && (
            <Row className="detail-tab-info">
              <div className="detail-howtouse">
                {parse(
                  reward_vouchers_detail.more_info
                    ? reward_vouchers_detail.more_info
                    : ""
                )}
              </div>
            </Row>
          )}
        </div>
        <div className="detail-button">
          <Button
            variant="danger"
            className="btn-detail-redeem border-0"
            onClick={() => {
              setOpenRedeemModal(true);
            }}
          >
            Redeem
          </Button>
        </div>
      </Container>
      <RedeemModal
        redeemtioType={reward_vouchers_detail.redemption_type}
        redeemptionImage={reward_vouchers_detail.thumbnail_img_url}
        redeemptionName={reward_vouchers_detail.name}
        redeemptionDescription={reward_vouchers_detail.description}
        redeemptionTitle={reward_vouchers_detail.merchant.name}
        redeemptionPoint={reward_vouchers_detail.points_label}
        show={openRedeemModal}
      >
        {reward_vouchers_detail.redemption_type === "mobile_topup" ||
        reward_vouchers_detail.redemption_type === "data_topup" ||
        reward_vouchers_detail.redemption_type === "gopay" ||
        reward_vouchers_detail.redemption_type === "balance_topup" ? (
          <FloatingLabel
            controlId="floatingInput"
            label="Phone number"
            className="mb-3"
          >
            <Form.Control
              type="number"
              variant="danger"
              placeholder="Phone number"
              value={payload.phone}
              onChange={(e) => {
                onChangePhoneNumber(e.target.value);
              }}
            />
          </FloatingLabel>
        ) : (
          ""
        )}

        {reward_vouchers_detail.redemption_type === "electricity_topup" && (
          <Form.Group as={Col} className="input-pln-number">
            <InputGroup className="mb-3 password">
              <img
                src={
                  showPlnNumber === "password"
                    ? Assets.iconEye
                    : Assets.iconEyeActive
                }
                onClick={() => {
                  setShowPlnNumber(
                    showPlnNumber === "password" ? "text" : "password"
                  );
                }}
                className="pln-img"
                alt="pln_image"
              />
              <Form.Control
                variant="danger"
                type={showPlnNumber}
                placeholder="PLN Number"
                value={payload.number}
                onChange={(e) => {
                  setPayload({ ...payload, number: e.target.value });
                }}
              />
            </InputGroup>
          </Form.Group>
        )}

        <div className="d-grid gap-2">
          <Button
            variant="danger"
            className="border-0"
            disabled={isLoading}
            onClick={() => redeemProcess(reward_vouchers_detail.points)}
          >
            Redeem
          </Button>
          <Button
            variant="outline-danger"
            style={{
              border:
                Object.keys(orgData).length > 0
                  ? `1px solid ${orgData.theme_color}`
                  : "",
              color: Object.keys(orgData).length > 0 ? orgData.theme_color : "",
            }}
            onClick={() => {
              setOpenRedeemModal(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </RedeemModal>
      <RedeemDialog
        title={resultData.status === 200 ? "Successful" : "Unsuccessful"}
        iconRedeem={reward_vouchers_detail.thumbnail_img_url}
        voucherRedeemName={reward_vouchers_detail.name}
        voucherRedeemDescription={reward_vouchers_detail.description}
        message={resultData.message}
        redeemptionType={reward_vouchers_detail.redemption_type}
        showDescription={
          reward_vouchers_detail.redemption_type === "e_voucher" ? false : true
        }
        show={openRedeemDialog}
        onHide={() => {
          setOpenRedeemDialog(false);
          navigate("/reward");
        }}
      />
    </DetailLayout>
  );
};

const mapStateToProps = (state) => ({
  reward_vouchers_detail: state.RewardSM.reward_vouchers_detail,
  profile: state.LoginSM.login,
  pointSummaryData: state.FinanceSM.pointSummaryData,
});

const mapDispatchToProps = (dispatch) => ({
  getRewardDetails: dispatch.RewardSM.getRewardDetails,
  redemptionVoucher: dispatch.RedeemSM.redemptionVoucher,
  setFinanceState: dispatch.FinanceSM.setFinanceState,
  setLoginData: dispatch.LoginSM.setLoginData,
});

export default connect(mapStateToProps, mapDispatchToProps)(VoucherDetail);
